module.exports = __webpack_public_path__ + "static/media/8-laparoscopic-vertical-sleeve-gastrectomy-surgery@3x.471bfe15.png";